import Svg, { Path } from "react-native-svg";

import { useAppTheme } from "@/hooks/useAppTheme";

export const AccountSidebarOutlineIcon = () => {
  return (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <Path
        d="M11 11C13.6036 11 15.7143 8.88933 15.7143 6.28571C15.7143 3.68209 13.6036 1.57143 11 1.57143C8.39637 1.57143 6.28571 3.68209 6.28571 6.28571C6.28571 8.88933 8.39637 11 11 11Z"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.9998 14.1429C6.75075 14.1429 3.10767 16.7373 1.56836 20.4286H20.4312C18.892 16.7373 15.2489 14.1429 10.9998 14.1429Z"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export const AccountSidebarFilledIcon = () => {
  const { resolvedColors } = useAppTheme();

  return (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.50001 6.28564C5.50001 3.24807 7.96245 0.785645 11 0.785645C14.0376 0.785645 16.5 3.24807 16.5 6.28564C16.5 9.32322 14.0376 11.7856 11 11.7856C7.96245 11.7856 5.50001 9.32322 5.50001 6.28564ZM10.9998 13.3571C6.42267 13.3571 2.50026 16.1525 0.843187 20.1262C0.742058 20.3686 0.768838 20.6457 0.914552 20.8643C1.06027 21.0828 1.30562 21.2142 1.56837 21.2142H20.4313C20.694 21.2142 20.9395 21.0828 21.0851 20.8643C21.2308 20.6457 21.2577 20.3686 21.1565 20.1262C19.4994 16.1525 15.577 13.3571 10.9998 13.3571Z"
        fill={resolvedColors.sidebar}
      />
    </Svg>
  );
};
